import { render, staticRenderFns } from "./BoxPlotVis.vue?vue&type=template&id=1415c941&scoped=true&"
import script from "./BoxPlotVis.vue?vue&type=script&lang=js&"
export * from "./BoxPlotVis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415c941",
  null
  
)

export default component.exports